export default __webpack_public_path__ + "static/media/epidemic.d68f22e1.svg";